import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { SuperAdminGuardService } from './super-admin-guard.service';
import { TestUiAccessService } from './test-ui-access.service';

/**
 * Guards the test UI route (`/dev-tools`): open in the local development
 * environment and for sessions a super admin switched to via the test UI,
 * otherwise the regular super admin rules apply (unauthenticated -> /login,
 * non-super-admin -> /).
 */
@Injectable({
  providedIn: 'root',
})
export class TestUiGuardService {
  private readonly testUiAccess = inject(TestUiAccessService);
  private readonly superAdminGuard = inject(SuperAdminGuardService);

  public canActivate(state: RouterStateSnapshot) {
    if (this.testUiAccess.bypassesSuperAdminCheck()) {
      return true;
    }
    return this.superAdminGuard.canActivate(state);
  }
}
